<template>
  <div class="bbp-accordion-content-cell-buttons">
    <div
      class="bbp-accordion-content-cell-buttons__item"
      @click="onClose"
    >
      cancel
    </div>
    <div
      class="bbp-accordion-content-cell-buttons__item"
      @click="onSave"
    >
      save
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPAccordionContentCellButtons',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    },
    onSave () {
      this.$emit('onSave')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-accordion-content-cell-buttons {
    display: grid;
    grid-template-columns: 51px 51px;
    grid-gap: 0 8px;
    z-index: 1;
    margin: 0 0 8px 0;

    &__item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 7px 6px 7px 6px;
      border-radius: 5px;
      font-size: 10px;
      font-weight: 600;
      line-height: 12px;
      text-transform: uppercase;
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        opacity: 0.8;
      }

      &:first-child {
        color: $color-gray;
      }

      &:last-child {
        background: $color-denim;
        color: $color-white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCellButtons.vue